import { Box, MenuItem, Popover, TextField } from '@mui/material';
import { TableFilterProps } from 'src/types/table';


export const TableFilter = ({
  anchorEl,
  activeColumn,
  columns,
  sortDirection,
  filterValue,
  onClose,
  onSort,
  onFilter,
}: TableFilterProps): JSX.Element =>
  <Popover
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}>
    {activeColumn && (
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
        {columns.find((col) => col.id === activeColumn)?.sortable && (
          <Box>
            <MenuItem onClick={() => onSort(activeColumn)}>
              Sort {sortDirection === 'asc' ? 'Descending' : 'Ascending'}
            </MenuItem>
          </Box>
        )}
        {columns.find((col) => col.id === activeColumn)?.filterable && (
          <TextField
            size="small"
            label="Filter"
            value={filterValue}
            onChange={(e) => onFilter(activeColumn, e.target.value)}
          />
        )}
      </Box>
    )}
  </Popover>

